import { useMutation } from '@tanstack/react-query';
import { getAllUsersSuperAdmin } from "@/api/user"; 
import { GetAllUsersSuperAdmin, UserData } from "@/types"; 
import { PostParam } from "@/types/index"; 

export function useGetAllUsersSuperAdmin(props?: PostParam) {
  const { onSuccess, onError } = props || {};

  return useMutation<UserData[], Error, GetAllUsersSuperAdmin>({
    mutationFn: getAllUsersSuperAdmin,
    onSuccess,
    onError
  });
}